import { QuestionSection } from "../Question";
import {
  Q_ACTIVE_SUBSCRIPTION,
  Q_TRANSITION_EXPLAINER,
} from "../questionTypes/b2c-to-b2b";
import {
  Q_ACCESS_EXCLUSIONS,
  Q_ACCESS_INELIGIBLE,
  Q_ACCESS_QUALIFYING,
  Q_ACCESS_WAIST_CIRCUMFERENCE,
} from "../questionTypes/cms-access";
import {
  Q_CONNECT_HEALTH_RECORDS_CONSENT,
  Q_CONNECT_HEALTH_RECORDS_IN_PROGRESS,
  Q_CONNECT_HEALTH_RECORDS_INTRO,
  Q_CONNECT_HEALTH_RECORDS_PERSONALIZATION,
  Q_CONNECT_HEALTH_RECORDS_PRIVACY,
} from "../questionTypes/connect-health-records";
import {
  Q_A1C,
  Q_BASELINE_HEALTH,
  Q_COMPLETE_PROFILE,
  Q_CONTINUE_PROGRAM,
  Q_COURSE_PACK_SELECTION,
  Q_CREATE_ACCOUNT,
  Q_CREATE_PASSWORD,
  Q_CULTURAL_IMPACTS,
  Q_DIABETES_DIAGNOSIS,
  Q_DIABETES_SUPPORT,
  Q_DIABETES_TYPE,
  Q_DIFFICULTIES,
  Q_EATING_DISORDER,
  Q_EATING_MOVING_AFFORDABLY,
  Q_EDUCATION,
  Q_ELIGIBILITY_CHECK,
  Q_ENROLLED_IN_MEDICARE,
  Q_ETHNICITY,
  Q_EXISTING_PASSWORD,
  Q_FAMILY_HISTORY,
  Q_FAMILY_HISTORY_WEIGHT,
  Q_GENDER,
  Q_GLP1_MEDICATION,
  Q_GLP1_WEIGHT,
  Q_GLUCOMETER_OWNERSHIP,
  Q_NON_MED_ELIGIBLE,
  Q_HAD_A1C_TESTED,
  Q_HEALTH_CARE_PROFESSIONAL,
  Q_HEALTH_CONDITIONS,
  Q_HEALTH_GOAL,
  Q_HEIGHT_WEIGHT,
  Q_HYPERTENSION,
  Q_IDEAL_WEIGHT,
  Q_LIABILITY_WAIVER_ALERT_BMI,
  Q_LIABILITY_WAIVER_ALERT_EATING_DISORDER,
  Q_LIABILITY_WAIVER_ALERT_IDEAL_WEIGHT,
  Q_LIABILITY_WAIVER_ALERT_PREGNANT,
  Q_LIABILITY_WAIVER_BMI,
  Q_LIABILITY_WAIVER_EATING_DISORDER,
  Q_LIABILITY_WAIVER_IDEAL_WEIGHT,
  Q_LIABILITY_WAIVER_PREGNANT,
  Q_LOCATION_STATE,
  Q_MEDICARE_CONSENT,
  Q_MEDICATIONS,
  Q_MENOPAUSE,
  Q_MENSTRUAL_CYCLE,
  Q_MOTIVATION,
  Q_MSK_PAIN,
  Q_MSK_PAIN_LEVEL,
  Q_NOOM_MED_MORE_OPTIONS,
  Q_NOOM_MED_OVERVIEW,
  Q_NURSING,
  Q_NUTRITION_BASICS,
  Q_OTHER_ETHNICITY,
  Q_OUTCOMES_A1C,
  Q_OUTCOMES_GLP1_MEDICATION,
  Q_OUTCOMES_HAD_A1C_TESTED,
  Q_OUTCOMES_HEALTH_CONDITIONS,
  Q_OUTCOMES_MEDICATIONS,
  Q_OUTCOMES_MSK_PAIN,
  Q_OUTCOMES_MSK_PAIN_LEVEL,
  Q_PERSONALIZATION_CONFIRMATION,
  Q_PERSONALIZATION_INTRO,
  Q_PERSONALIZING_PROGRAM_V2,
  Q_PHQ_1,
  Q_PHQ_2,
  Q_PHQ_3,
  Q_PHQ_4,
  Q_PHQ_SUPPORT_RESOURCES,
  Q_PHYSICAL_ACTIVITY,
  Q_PREDIABETES_HISTORY,
  Q_PREGNANT,
  Q_PRIMARY_CARE_PROVIDER,
  Q_PROGRAM_OVERVIEW,
  Q_PROGRAM_RESULT,
  Q_REASON_FOR_LOSING_WEIGHT,
  Q_RETRIAGE_A1C,
  Q_RETRIAGE_DIFFICULTIES,
  Q_RETRIAGE_EATING_DISORDER,
  Q_RETRIAGE_EDUCATION,
  Q_RETRIAGE_ETHNICITY,
  Q_RETRIAGE_FAMILY_HISTORY,
  Q_RETRIAGE_GENDER,
  Q_RETRIAGE_HEALTH_CARE_PROFESSIONAL,
  Q_RETRIAGE_HEALTH_CONDITIONS,
  Q_RETRIAGE_HEIGHT_WEIGHT,
  Q_RETRIAGE_HYPERTENSION,
  Q_RETRIAGE_MOTIVATION,
  Q_RETRIAGE_PHQ_1,
  Q_RETRIAGE_PHQ_2,
  Q_RETRIAGE_PHQ_3,
  Q_RETRIAGE_PHQ_4,
  Q_RETRIAGE_PHQ_SUPPORT_RESOURCES,
  Q_RETRIAGE_PHYSICAL_ACTIVITY,
  Q_RETRIAGE_PREDIABETES_HISTORY,
  Q_RETRIAGE_PREGNANT,
  Q_RETRIAGE_SCALE_OPT_IN,
  Q_RETRIAGE_SEX,
  Q_SCALE_EARNING_OPT_IN,
  Q_SCALE_EARNING_OPT_IN_SCALE_SURVEY,
  Q_SCALE_OPT_IN,
  Q_SCALE_OPT_IN_ELIGIBILITY_CHECK,
  Q_SCALE_OPT_IN_SCALE_SURVEY,
  Q_SCALE_ORDER_CONFIRMATION,
  Q_SCALE_SHIPPING_ADDRESS,
  Q_SCREENED_OUT,
  Q_SEX,
  Q_SLEEP,
  Q_SOCIAL_DETERMINANTS_OF_HEALTH,
  Q_STRESS_EATING,
  Q_WOMENS_HEALTH,
} from "../questionTypes/dpp-triage";
import {
  Q_EXERCISE,
  Q_OUTCOMES_SURVEY_COMPLETE,
  Q_OUTCOMES_WEIGHT,
  Q_REACHING_HEALTH_GOALS,
} from "../questionTypes/outcomes";
import {
  Q_CONFIRM_CHANGE_PROGRAM_DIABETES,
  Q_CONFIRM_CHANGE_PROGRAM_DPP,
  Q_CONFIRM_CHANGE_PROGRAM_MED,
  Q_RETRIAGE_ELIGIBILITY_CHECK,
  Q_RETRIAGE_INTRO,
  Q_RETRIAGE_KEEP_PLAN,
  Q_RETRIAGE_MED_SIGNUP,
  Q_RETRIAGE_TRANSITION,
} from "../questionTypes/retriage";
import { Q_RETRIAGE_PROGRAM_RESULT } from "../questionTypes/retriage/RetriageProgramResult";

const QuestionSets: Record<string, QuestionSection[]> = {
  DPP_SURVEY: [
    {
      descriptionKey: "survey.progressBar.accountCreation",
      percentage: 10,
      questions: [
        Q_ELIGIBILITY_CHECK,
        Q_CREATE_ACCOUNT,
        Q_CREATE_PASSWORD,
        Q_EXISTING_PASSWORD,
        Q_ACCESS_QUALIFYING,
        Q_ACCESS_EXCLUSIONS,
        Q_ACCESS_INELIGIBLE,
      ],
    },
    {
      descriptionKey: "survey.progressBar.demographics",
      percentage: 20,
      questions: [
        Q_HEALTH_GOAL,
        Q_PROGRAM_OVERVIEW,
        Q_EATING_DISORDER,
        Q_LIABILITY_WAIVER_ALERT_EATING_DISORDER,
        Q_LIABILITY_WAIVER_EATING_DISORDER,
        Q_HEIGHT_WEIGHT,
        Q_ACCESS_WAIST_CIRCUMFERENCE,
        Q_LIABILITY_WAIVER_ALERT_BMI,
        Q_LIABILITY_WAIVER_BMI,
        Q_IDEAL_WEIGHT,
        Q_LIABILITY_WAIVER_ALERT_IDEAL_WEIGHT,
        Q_LIABILITY_WAIVER_IDEAL_WEIGHT,
        Q_ETHNICITY,
        Q_OTHER_ETHNICITY,
        Q_SEX,
        Q_WOMENS_HEALTH,
        Q_MENOPAUSE,
        Q_MENSTRUAL_CYCLE,
        Q_GENDER,
        Q_PREGNANT,
        Q_LIABILITY_WAIVER_ALERT_PREGNANT,
        Q_LIABILITY_WAIVER_PREGNANT,
        Q_NURSING,
      ],
    },
    {
      descriptionKey: "survey.progressBar.eatingHabits",
      percentage: 10,
      questions: [
        Q_SOCIAL_DETERMINANTS_OF_HEALTH,
        Q_NUTRITION_BASICS,
        Q_EATING_MOVING_AFFORDABLY,
        Q_CULTURAL_IMPACTS,
      ],
    },
    {
      descriptionKey: "survey.progressBar.healthProfile",
      percentage: 40,
      questions: [
        Q_BASELINE_HEALTH,
        Q_HEALTH_CONDITIONS,
        Q_DIABETES_DIAGNOSIS,
        Q_DIABETES_TYPE,
        Q_PRIMARY_CARE_PROVIDER,
        Q_DIABETES_SUPPORT,
        Q_MEDICATIONS,
        Q_GLP1_MEDICATION,
        Q_GLP1_WEIGHT,
        Q_NON_MED_ELIGIBLE,
        Q_HAD_A1C_TESTED,
        Q_A1C,
        Q_MSK_PAIN,
        Q_MSK_PAIN_LEVEL,
        Q_PHQ_1,
        Q_PHQ_2,
        Q_PHQ_3,
        Q_PHQ_4,
        Q_PHQ_SUPPORT_RESOURCES,
        Q_STRESS_EATING,
        Q_SLEEP,
        Q_REASON_FOR_LOSING_WEIGHT,
        Q_FAMILY_HISTORY_WEIGHT,
        Q_LOCATION_STATE,
        Q_NOOM_MED_OVERVIEW,
        Q_NOOM_MED_MORE_OPTIONS,
        Q_ENROLLED_IN_MEDICARE,
        Q_MEDICARE_CONSENT,
        Q_CONTINUE_PROGRAM,
        Q_PREDIABETES_HISTORY,
        Q_HYPERTENSION,
        Q_FAMILY_HISTORY,
        Q_PHYSICAL_ACTIVITY,
        Q_DIFFICULTIES,
        Q_EDUCATION,
        Q_MOTIVATION,
        Q_HEALTH_CARE_PROFESSIONAL,
        Q_SCREENED_OUT,
      ],
    },
    {
      descriptionKey: "survey.progressBar.curriculumPersonalization",
      percentage: 10,
      questions: [
        Q_PERSONALIZING_PROGRAM_V2,
        Q_PROGRAM_RESULT,
        Q_PERSONALIZATION_INTRO,
        Q_COURSE_PACK_SELECTION,
        Q_PERSONALIZATION_CONFIRMATION,
      ],
    },
    {
      descriptionKey: "survey.progressBar.profileCreation",
      percentage: 10,
      questions: [
        Q_GLUCOMETER_OWNERSHIP,
        Q_SCALE_OPT_IN,
        Q_SCALE_EARNING_OPT_IN,
        Q_COMPLETE_PROFILE,
      ],
    },
  ],
  RECURRING_OUTCOMES: [
    {
      descriptionKey: "survey.progressBar.progressCheckIn",
      percentage: 100,
      questions: [
        Q_OUTCOMES_WEIGHT,
        Q_OUTCOMES_HEALTH_CONDITIONS,
        Q_OUTCOMES_MEDICATIONS,
        Q_OUTCOMES_GLP1_MEDICATION,
        Q_OUTCOMES_HAD_A1C_TESTED,
        Q_OUTCOMES_A1C,
        Q_OUTCOMES_MSK_PAIN,
        Q_OUTCOMES_MSK_PAIN_LEVEL,
        Q_PHQ_1,
        Q_PHQ_2,
        Q_PHQ_3,
        Q_PHQ_4,
        Q_PHQ_SUPPORT_RESOURCES,
        Q_EXERCISE,
        Q_REACHING_HEALTH_GOALS,
        Q_OUTCOMES_SURVEY_COMPLETE,
      ],
    },
  ],
  RETRIAGE_SURVEY: [
    {
      descriptionKey: "survey.progressBar.healthRiskAssessment",
      percentage: 100,
      questions: [
        Q_RETRIAGE_ELIGIBILITY_CHECK,
        Q_RETRIAGE_INTRO,
        Q_RETRIAGE_HEIGHT_WEIGHT,
        Q_LIABILITY_WAIVER_ALERT_BMI,
        Q_LIABILITY_WAIVER_BMI,
        Q_RETRIAGE_EATING_DISORDER,
        Q_LIABILITY_WAIVER_ALERT_EATING_DISORDER,
        Q_LIABILITY_WAIVER_EATING_DISORDER,
        Q_RETRIAGE_ETHNICITY,
        Q_OTHER_ETHNICITY,
        Q_RETRIAGE_SEX,
        Q_RETRIAGE_GENDER,
        Q_RETRIAGE_PREGNANT,
        Q_LIABILITY_WAIVER_ALERT_PREGNANT,
        Q_LIABILITY_WAIVER_PREGNANT,
        Q_RETRIAGE_HEALTH_CONDITIONS,
        Q_DIABETES_DIAGNOSIS,
        Q_DIABETES_TYPE,
        Q_PRIMARY_CARE_PROVIDER,
        Q_DIABETES_SUPPORT,
        Q_GLP1_MEDICATION,
        Q_GLP1_WEIGHT,
        Q_NON_MED_ELIGIBLE,
        Q_RETRIAGE_PHQ_1,
        Q_RETRIAGE_PHQ_2,
        Q_RETRIAGE_PHQ_3,
        Q_RETRIAGE_PHQ_4,
        Q_RETRIAGE_PHQ_SUPPORT_RESOURCES,
        Q_REASON_FOR_LOSING_WEIGHT,
        Q_FAMILY_HISTORY_WEIGHT,
        Q_LOCATION_STATE,
        Q_NOOM_MED_OVERVIEW,
        Q_CONFIRM_CHANGE_PROGRAM_MED,
        Q_NOOM_MED_MORE_OPTIONS,
        Q_ENROLLED_IN_MEDICARE,
        Q_MEDICARE_CONSENT,
        Q_RETRIAGE_PREDIABETES_HISTORY,
        Q_RETRIAGE_A1C,
        Q_RETRIAGE_HYPERTENSION,
        Q_RETRIAGE_FAMILY_HISTORY,
        Q_RETRIAGE_PHYSICAL_ACTIVITY,
        Q_RETRIAGE_DIFFICULTIES,
        Q_RETRIAGE_EDUCATION,
        Q_RETRIAGE_MOTIVATION,
        Q_RETRIAGE_HEALTH_CARE_PROFESSIONAL,
        Q_PERSONALIZING_PROGRAM_V2,
        Q_RETRIAGE_SCALE_OPT_IN,
        Q_RETRIAGE_MED_SIGNUP,
        Q_RETRIAGE_PROGRAM_RESULT,
        Q_CONFIRM_CHANGE_PROGRAM_DIABETES,
        Q_CONFIRM_CHANGE_PROGRAM_DPP,
        Q_RETRIAGE_TRANSITION,
        Q_RETRIAGE_KEEP_PLAN,
      ],
    },
  ],
  TRANSITION_SURVEY: [
    {
      descriptionKey: "survey.progressBar.transition",
      percentage: 100,
      questions: [Q_ACTIVE_SUBSCRIPTION, Q_TRANSITION_EXPLAINER],
    },
  ],
  SCALE_OPT_IN_SURVEY: [
    {
      descriptionKey: "",
      percentage: 100,
      questions: [
        Q_SCALE_OPT_IN_ELIGIBILITY_CHECK,
        Q_SCALE_OPT_IN_SCALE_SURVEY,
        Q_SCALE_EARNING_OPT_IN_SCALE_SURVEY,
        Q_SCALE_SHIPPING_ADDRESS,
        Q_SCALE_ORDER_CONFIRMATION,
      ],
    },
  ],
  CONNECT_HEALTH_RECORDS_SURVEY: [
    {
      descriptionKey: "",
      percentage: 100,
      questions: [
        Q_CONNECT_HEALTH_RECORDS_INTRO,
        Q_CONNECT_HEALTH_RECORDS_PRIVACY,
        Q_CONNECT_HEALTH_RECORDS_CONSENT,
        Q_CONNECT_HEALTH_RECORDS_IN_PROGRESS,
        Q_CONNECT_HEALTH_RECORDS_PERSONALIZATION,
      ],
    },
  ],
  WIP: [
    {
      descriptionKey: "",
      percentage: 0,
      questions: [],
    },
  ],
};

export default QuestionSets;
